import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "../lib/auth-guards";
import { OrganizationManagementPageContainer } from "@charphq/ui/components/organization-management/organization-management-page-container";

export const Route = createFileRoute("/organizations")({
  beforeLoad: async () => {
    // Require authentication
    await requireAuth();
    // Organization management is restricted to superadmins via the component
  },
  component: OrganizationsPageComponent,
});

function OrganizationsPageComponent() {
  return (
    <OrganizationManagementPageContainer
      route={Route}
      breadcrumbs={[{ label: "Home", href: "/" }, { label: "Organizations" }]}
    />
  );
}
